import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getGeneratedBagQRTags,
    getAlGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    getOperationEntityOptionsByGroupForDropDown,
    GetCollectionPointsFilter,
    getCollectionPointOptionsFilter,
    getOperationEntitiesByGroupForDropDown,
};

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}
async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getOperationEntityOptionsByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = {
            name: item[1]["operationEntityName"],
            shortName: getShortName(item[1], [
                "operationEntityShortName",
                "estateShortName",
                "shortName",
                "shortCode",
                "operationEntityCode",
                "estateCode"
            ])
        };
    }
    return operationEntityArray;
}

async function getAllOperationEntitiesForDropDown(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function getCollectionPointOptionsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = {
            name: item[1]["collectionPointName"],
            shortName: getShortName(item[1], [
                "collectionPointShortName",
                "divisionShortName",
                "shortName",
                "shortCode",
                "collectionPointCode",
                "divisionCode"
            ])
        };
    }
    return collectionPointArray;
}

async function getGeneratedBagQRTags(groupID, operationEntityID, collectionPointID) {
    const data = {
        GroupID: parseInt(groupID),
        OperationEntityID: parseInt(operationEntityID),
        CollectionPointID: parseInt(collectionPointID) || 0
    };
    const res = await CommonPost('/api/BagQRCodeRePrint/GetBagQRCodeRePrint', null, data);
    return res;
}

function getShortName(data, keys) {
    for (const key of keys) {
        if (data[key]) {
            return data[key];
        }
    }
    return "";
}
